'use client';

import { Controller } from 'react-hook-form';
import { Slider } from '@/shared/ui/slider';
import { FormFieldProps } from './types';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

type Props = FormFieldProps<typeof Slider>;
export const FormSlider = ({
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    ...props
}: Props) => {
    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({ field }) => {
                const parsedRules = parseRulesForInputAttributes(rules);

                return (
                    <Slider
                        {...parsedRules}
                        min={parsedRules.min ? parseFloat(parsedRules.min.toString()) : undefined}
                        max={parsedRules.max ? parseFloat(parsedRules.max.toString()) : undefined}
                        name={field.name}
                        onValueChange={(value) => field.onChange(value)}
                        value={field.value}
                        disabled={field.disabled}
                        {...props}
                    />
                );
            }}
        />
    );
};
